// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-module--layout--2I3WK","layoutWithbg":"layout-module--layout--withbg--1ffa9"};